export default __webpack_public_path__ + "locales/en/PrivacyPage.json?hash=306e75073f50c4c48d1ec81c45d2ae2d";